module.exports = __webpack_public_path__ + "static/media/alert.0935afd9.svg";